import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-dealer-fota-approved-files',
  templateUrl: './dealer-fota-approved-files.component.html',
  styleUrls: ['./dealer-fota-approved-files.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatTooltip,
    MatError,
    NgxPaginationModule,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class DealerFotaApprovedFilesComponent implements OnInit {
  fileNameForm: FormGroup = this.formBuilder.group({});
  page = 1;
  searchText = '';
  totalLength = 0;
  pagesize = 10;
  allFiles = [];
  userPermission = [];
  DealerFotaCreate = false;
  DealerFotaDelete = false;
  DealerFotaView = false;
  constructor(
    private formBuilder: FormBuilder,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setUploadCsvLogForm();
    this.checkPermission();
    if (this.DealerFotaView) {
      this.getFileListData();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Dealer FOTA' && element.view === false) {
          this.navigateBack();
        }
        if (element.pageName === 'Dealer FOTA' && element.view === true) {
          this.DealerFotaView = true;
        }
        if (element.pageName === 'Dealer FOTA' && element.create === true) {
          this.DealerFotaCreate = true;
        }
        if (element.pageName === 'Dealer FOTA' && element.delete === true) {
          this.DealerFotaDelete = true;
        }
      }
    );
  }

  setUploadCsvLogForm() {
    this.fileNameForm = this.formBuilder.group({
      fileName: ['', [SharedValidators.requiredAndNoEmptySpaces]],
      searchText: [''],
    });
  }

  saveFirmwareVersion() {
    if (this.fileNameForm.valid) {
      // Trim the input value
      const trimmedFileName = this.fileNameForm.value.fileName?.trim();

      // Set the trimmed value back to the form control for validation feedback
      this.fileNameForm.controls['fileName'].setValue(trimmedFileName);

      // Check if the trimmed value is valid (non-empty)
      if (!trimmedFileName) {
        console.error(
          'File name cannot be empty. Please provide a valid name.'
        );
        this.fileNameForm.controls['fileName'].setErrors({ required: true });
        return;
      }
      // Prepare the data for the API request
      const requestBody = {
        fileName: trimmedFileName,
      };

      // Show spinner
      this.spinner.show();

      // Make API call with the request body
      this.apiMicroservice.saveFirmwareVersion(requestBody).subscribe(
        (res) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(res.msg);
          this.setUploadCsvLogForm();
          this.getFileListData(); // Fetch updated file list if necessary
        },
        (error) => {
          console.error(error);
          this.apiMicroservice.openSnackbar(
            error.error?.msg || 'Something went wrong. Please try again.'
          );
          this.spinner.hide();
        }
      );
    } else {
      SharedValidators.markAllAsTouched(this.fileNameForm);
    }
  }

  getFileListData() {
    this.allFiles = [];
    this.spinner.show();
    this.apiMicroservice
      .getFiledata(this.page, this.pagesize, this.searchText)
      .subscribe({
        next: (res) => {
          this.allFiles = res.data.map((file) => ({
            ...file,
            createdAt: new Date(file.createdAt).toLocaleString('en-GB', {
              timeZone: 'Asia/Kolkata',
              hour12: true,
            }),
          }));
          this.totalLength = res.count;
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
          console.error(err);
        },
      });
  }

  navigateBack() {
    this.apiMicroservice.back();
  }

  onPageChange(event: number) {
    this.page = event;
    this.getFileListData();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.pagesize = event;
    this.getFileListData();
  }

  onSearch(event: string) {
    this.searchText = event;
    this.fileNameForm.value.searchText?.trim();
    this.getFileListData();
  }

  delete(id) {
    if (confirm('Do you want to delete this file?')) {
      this.apiMicroservice.deleteFile(id).subscribe((res) => {
        this.apiMicroservice.openSnackbar(res.message);
        this.fileNameForm.reset();
        this.setUploadCsvLogForm();
        this.getFileListData(); // Fetch updated file list if necessary
      });
    }
  }
}
